import { Skeleton } from "@/components/ui/skeleton";

export function PendingPane() {
  return (
    <div className="flex h-full min-h-0 flex-1 flex-col gap-3 p-6">
      <Skeleton className="h-7 w-1/3" />
      <Skeleton className="h-4 w-full" />
      <Skeleton className="h-4 w-5/6" />
      <Skeleton className="min-h-48 w-full flex-1" />
    </div>
  );
}
